<template>
  <div ref="protectedPage" class="universe-home">
    <div class="cosmic-background" aria-hidden="true"></div>

    <header class="site-header">
      <a class="brand-lockup" href="/" aria-label="宇宙之幂首页">
        <span class="brand-mark">
          <img
            src="/static/favicontu.ico"
            alt=""
            draggable="false"
            width="38"
            height="38"
          >
        </span>
        <h1>宇宙之幂 <span aria-hidden="true">|</span> <b lang="en">UniversePower</b></h1>
      </a>
      <nav class="header-actions" aria-label="页面操作">
        <span class="download-menu">
          <a
            class="download-link"
            href=""
            aria-haspopup="true"
            @click.prevent
          >获取【宇宙之幂】</a>
          <span class="download-card" role="dialog" aria-label="扫码获取宇宙之幂">
            <span class="qr-shell">
              <img
                src="/static/Snipaste_2026-08-12_09-32-07.png"
                alt="宇宙之幂下载二维码"
                draggable="false"
                width="206"
                height="206"
              >
            </span>
            <span class="download-card-caption">扫码获取宇宙之幂 APP</span>
          </span>
        </span>
        <button class="language-option" type="button" aria-label="切换为 English">English</button>
      </nav>
    </header>

    <main class="experience" aria-label="宇宙之幂产品宇宙">
      <div id="universeStage" class="universe-stage" aria-live="off"></div>
    </main>

    <footer class="site-footer">
      <div class="footer-row footer-primary">
        <span class="company-name">宇宙之幂（深圳）科技集团有限公司</span>
        <span class="footer-item">用户协议</span>
        <span class="footer-item">隐私政策</span>
        <span class="footer-item">投诉反馈</span>
      </div>
      <div class="footer-row footer-records">
        <span>粤ICP备2024237244号@2024 © 宇宙之幂</span>
      </div>
    </footer>
  </div>
</template>

<script>
import {
  configureUniverseBody,
  loadUniverseExperience
} from '@/lib/universeExperience'
import { installImageProtection } from '@/lib/imageProtection'

export default {
  name: 'UniverseHome',
  mounted () {
    this.removeImageProtection = installImageProtection(this.$refs.protectedPage)
    configureUniverseBody()
    loadUniverseExperience().catch(error => {
      console.error('Universe experience failed to load', error)
    })
  },
  beforeDestroy () {
    if (this.removeImageProtection) this.removeImageProtection()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/UniverseHome.vue